import { ActionButtonLegacy } from 'components/common-form/sidePanel/quoteActionsLegacy/ActionButtonLegacy';
import { FC } from 'react';

import type { AddonQuoteActionsProps } from './AddonQuoteAction.connect';

export const AddOnQuoteActionComponent: FC<AddonQuoteActionsProps> = ({
  isDisabled,
  onAddOnQuoteRequested,
  isNotReadyToQuote,
}) => {
  return (
    <div className="d-flex justify-content-between" data-e2e="quote-actions">
      <ActionButtonLegacy
        className="w-100"
        name="AddonQuote"
        onQuoteAction={onAddOnQuoteRequested}
        isDisabled={isDisabled}
        isNotReadyToQuote={isNotReadyToQuote}
      />
    </div>
  );
};
